<html [lang]="(currentLanguage$ | async)">
<div class="full-content" [class.ai-page]="isAiSearchPage">
  <msal-redirect></msal-redirect>
  <lib-module-header *ngIf="!isAiSearchPage" [moduleDetails]="isAuthenticated ?  modules : []" [userName]="userName"
    [userMenuItemsUnified]="userMenuItems" [moduleHeaderData]="moduleHeaderData" [isInternalUser]="(internalUser$ | async) ?? false" [isAuthenticated]="isAuthenticated" (onLogout)="logout()" [pages]="isAuthenticated ? [] : pages"
    [infoPages]="isAuthenticated ? infoPages : infoPagesForNonAuthenticated" [activePage]="activePage"
    [languageConfig]="languageConfig$" (onPageChange)="onPageChange($event)" (onLogoClick)="onLogoClick()" (onLangChange)="onLangChange()"/>
  <div class="content" [class.ai-content]="isAiSearchPage">
    <app-authentication-new *ngIf="!isAuthenticated && !isAnonymous"></app-authentication-new>
    <ng-container *ngIf="isAuthenticated || isAnonymous">
      <ng-container [ngSwitch]="activePage.id" *ngIf="!isAiSearchPage">
        <app-main *ngSwitchCase="0"></app-main>
        <terms *ngSwitchCase="1"></terms>
        <about  [currentLanguage]="currentLanguage$" *ngSwitchCase="2"></about>
        <accessibility *ngSwitchCase="4"></accessibility>
      </ng-container>
      <router-outlet *ngIf="isAiSearchPage"></router-outlet>
    </ng-container>
  </div>
</div>
</html>